import type { CSSProperties } from 'react'
import { ContentGroup } from '@/shared/ui'
import { designTokens } from '@/shared/lib/design-tokens'
import previewImage from '@/shared/assets/onboarding/desktop_onboarding.png'

export type OnboardingPreviewProps = {
  className?: string
  style?: CSSProperties
  imageFit?: 'cover' | 'contain'
}

export function OnboardingPreview({
  className,
  style,
  imageFit = 'cover',
}: OnboardingPreviewProps) {
  const previewRadius = designTokens.components.onboarding.desktop.previewRadius

  return (
    <ContentGroup
      variant="contentDesktop"
      className={className}
      style={{
        padding: designTokens.spacing.xxs,
        height: designTokens.components.onboarding.desktop.panelHeight,
        ...style,
      }}
    >
      <div
        className="w-full flex-1"
        style={{
          backgroundColor: designTokens.colors.background.white,
          borderRadius: previewRadius,
          overflow: 'hidden',
        }}
      >
        <img
          src={previewImage}
          alt=""
          aria-hidden="true"
          className="h-full w-full"
          style={{
            objectFit: imageFit,
            borderRadius: previewRadius,
          }}
        />
      </div>
    </ContentGroup>
  )
}
